module.exports = __webpack_public_path__ + "static/img/partners20.b195440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners20.png
// module id = 5wF4
// module chunks = 9